/* eslint-disable */
import { produce } from "immer";
import {
  TRANSERIN_FETCH_START,
  TRANSERIN_FETCH_SUCCESS,
  TRANSERIN_FETCH_FAILURE,
} from "../actions/types";

const transferIn = (
  state = {
    transferInFetching: false,
    transferInData: [],
    transferInError: null,
  },
  action,
) => {
  switch (action.type) {
    case TRANSERIN_FETCH_START:
      return produce(state, (draft) => {
        draft.transferInFetching = true;
      });
    case TRANSERIN_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.transferInFetching = true;
        draft.transferInData = action.data;
        draft.transferInFetching = false;
      });
    case TRANSERIN_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.transferInFetching = false;
        draft.transferInError = action.error;
      });
    default:
      return state;
  }
};

export default transferIn;
